(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var scriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
  var serviceWorkerUrl = scriptSrc ? scriptSrc.replace(/pwa-register\.js(\?.*)?$/, 'pwa-sw.js$1') : '/pwa-sw.js';
  var deferredInstallPrompt = null;

  window.SweetDealsPWA = window.SweetDealsPWA || {};
  window.SweetDealsPWA.promptInstall = function () {
    if (!deferredInstallPrompt) return Promise.resolve(false);

    deferredInstallPrompt.prompt();
    return deferredInstallPrompt.userChoice
      .then(function (choice) {
        deferredInstallPrompt = null;
        window.SweetDealsPWA.deferredPrompt = null;
        return choice && choice.outcome === 'accepted';
      })
      .catch(function () {
        return false;
      });
  };

  window.addEventListener('beforeinstallprompt', function (event) {
    event.preventDefault();
    deferredInstallPrompt = event;
    window.SweetDealsPWA.deferredPrompt = event;
    document.dispatchEvent(new CustomEvent('pwa:installable'));
  });

  window.addEventListener('appinstalled', function () {
    deferredInstallPrompt = null;
    window.SweetDealsPWA.deferredPrompt = null;
    document.dispatchEvent(new CustomEvent('pwa:installed'));
  });

  var themeColorMeta = document.querySelector('meta[name="theme-color"]');
  if (themeColorMeta && !themeColorMeta.getAttribute('content')) {
    themeColorMeta.setAttribute('content', '#9B046F');
  }

  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', function () {
    navigator.serviceWorker
      .register(serviceWorkerUrl, { scope: '/' })
      .catch(function () {
        return navigator.serviceWorker.register(serviceWorkerUrl);
      })
      .catch(function (error) {
        if (window.console && console.info) console.info('[PWA] Service worker registration skipped:', error);
      });
  });
})();
